import * as React from 'react';
import { useRouter } from 'next/router';
import { LoaderScreen } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useDispatch } from '@grandvisionhq/state';
import { getSessionStorageItem, StringGuard } from '@grandvisionhq/utils';
import { SocialLoginModalContainer } from '../components/SocialLoginModal/SocialLoginModalContainer.js';
import { loggedOut } from '../Logout/actions.js';
import { parseHash } from './actions.js';

const Callback = ({ type  })=>{
    const dispatch = useDispatch();
    const [loginMethod, setLoginMethod] = React.useState('');
    const { href: profileRoute  } = useLink({
        route: 'me.profile'
    }) || {};
    const { asPath: callbackReturnPath , query  } = useRouter();
    const returnPathFromSession = getSessionStorageItem('login_returnPath');
    const returnPathAfterLogin = returnPathFromSession != null && returnPathFromSession != '"/"' ? returnPathFromSession.replace(/['"]+/g, '') : profileRoute || '';
    React.useEffect(()=>{
        if (query.loginMethod) {
            setLoginMethod(StringGuard.guard('social.loginMethod', query.loginMethod));
        }
        /**
     * When we are in the social login flow, we need to give the user the chance to indicate
     * they want to merge accounts. While they make a choice, we don't want to parse the URL hash yet.
     *
     * parseHash will be triggered from the SocialLoginModal.
     */ if (loginMethod === 'social') {
            return;
        }
        if (type === 'callback') {
            dispatch(parseHash());
        }
        if (type === 'logged-out') {
            dispatch(loggedOut(callbackReturnPath));
        }
    }, [
        type,
        query.loginMethod,
        loginMethod,
        dispatch,
        callbackReturnPath
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LoaderScreen, {
        height: 50
    }), loginMethod === 'social' && /*#__PURE__*/ React.createElement(SocialLoginModalContainer, {
        parseHash: parseHash,
        loggedOut: loggedOut,
        returnPath: returnPathAfterLogin
    }));
};
var Callback$1 = Callback;

export { Callback$1 as default };
//# sourceMappingURL=Callback.js.map
